var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5,
    r: 8,
    fill: "#B3B3B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29193 10.4998L6.81341 8.02132C6.61786 7.82577 6.61786 7.50872 6.81341 7.31317C7.00896 7.11762 7.32601 7.11762 7.52156 7.31317L10.0001 9.79169L12.4786 7.31317C12.6742 7.11762 12.9912 7.11762 13.1868 7.31317C13.3823 7.50872 13.3823 7.82577 13.1868 8.02132L10.7082 10.4998L13.1868 12.9784C13.3823 13.1739 13.3823 13.491 13.1868 13.6865C12.9912 13.8821 12.6742 13.8821 12.4786 13.6865L10.0001 11.208L7.52156 13.6865C7.32601 13.8821 7.00896 13.8821 6.81341 13.6865C6.61786 13.491 6.61786 13.1739 6.81341 12.9784L9.29193 10.4998Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.93f4cc89.svg";
export { ForwardRef as ReactComponent };